import register from "preact-custom-element";
import { useEffect, useRef } from "preact/hooks";

function SearchPanel({ search }) {
  const sectionRef = useRef();

  useEffect(() => {
    sectionRef.current
      .querySelector(".js-search-header-close")
      .addEventListener("click", () => {
        document
          .querySelector("search-panel .site-header__search-container")
          .classList.toggle("is-active");
      });
  }, []);

  return <div ref={sectionRef}>{search}</div>;
}

register(SearchPanel, "search-panel", []);
